import {Injectable, isDevMode} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Injectable({providedIn: 'root'})
export class RouteService {

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute) {
    }

    go(routes: string[], pathVariables: any = {}, queryParams?: object, config?: ConfigRoute): void {

        // Get to string
        let path: string = routes.join('/');
        // Replace paths variable
        Object.keys(pathVariables).forEach(key => {
            path = path.replace(':'.concat(key), pathVariables[key]);
        });

        // noinspection JSIgnoredPromiseFromCall
        this.router.navigate([path], {queryParams});

        if (isDevMode()) {
            console.log('%c path: ' + path, 'background: #f2f2f2; color: #0080d0; padding:5px; line-height: 25px');
        }
    }

    goto(route: string, pathVariables: any = {}, queryParams?: object, config?: ConfigRoute): void {

        // Replace paths variable
        Object.keys(pathVariables).forEach(key => {
            route = route.replace(':'.concat(key), pathVariables[key]);
        });

        // noinspection JSIgnoredPromiseFromCall
        this.router.navigate([route], {queryParams});

        if (isDevMode()) {
            console.log('%c path: ' + route, 'background: #f2f2f2; color: #0080d0; padding:5px; line-height: 25px');
        }
    }

    goByUrl(url: string): void {
        this.router.navigateByUrl(url);
    }

    reload(): void {
        location.reload();
    }

    clearQueryParams(qp = {}): void {
        this.router.navigate([], {queryParams: {...qp}, queryParamsHandling: 'merge'});
    }

    clearAllQueryParams(): void {
        this.router.navigate([], {queryParams: {}});
    }

    clearAllQueryParamsExcept(qp = {}): void {
        this.clearAllQueryParams();
        this.updateQueryParams(qp);
    }

    gotoExternalLink(link: string, newTab: boolean = true): void {
        window.open(link, newTab ? '_blank' : '_self');
    }

    updateQueryParams(queryParams: any): void {
        this.router.navigate(
            [],
            {
                relativeTo: this.activatedRoute,
                queryParams,
                queryParamsHandling: 'merge', // remove to replace all query params by provided
            });
    }

    joinRoutes(arr: string[]): string {
        return '/' + arr.join('/');
    }
}

export interface ConfigRoute {
    keepParam?: boolean;
}
